import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "authLayout__rightSide choseEnterprise" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "choseEnterprise__title" }, "请选择企业", -1)
const _hoisted_3 = { class: "choseEnterprise__list" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enterpriseList, (item, $index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass({ active: $index === _ctx.selectIndex }),
          onClick: ($event: any) => (_ctx.selectIndex = $index)
        }, [
          _createTextVNode(_toDisplayString(item.enterpriseName) + " ", 1),
          _createVNode(_component_app_icon, { type: "check" })
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createVNode(_component_a_button, {
      type: "primary",
      class: "choseEnterprise__button",
      onClick: _ctx.onSubmit
    }, {
      default: _withCtx(() => [
        _createTextVNode("进入企业工作台")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}